import { CSSProperties } from 'react';
import styled from 'styled-components';

import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { createCornerMap } from '@r1-frontend/ui-react/experimental/tooltip/helpers';
import { TTooltipPosition } from '@r1-frontend/ui-react/experimental/tooltip/types';

export const TooltipArrowContainer = styled(IndentContainer)<{ position: TTooltipPosition }>`
    display: flex;
    align-self: ${({ position }) => createCornerMap<CSSProperties['alignSelf']>({
        position,
        onCornerLeft: 'flex-start',
        onCornerRight: 'flex-end',
        onDefault: undefined,
    })};
`;

export const TooltipContainer = styled(ListContainer)<Pick<CSSProperties, 'zIndex'>>`
    align-items: center;
    z-index: ${p => p.zIndex};
`;
